import React from 'react'

import { Caption } from 'ui/acro'

const NavbarLink = ({ as = 'a', ...rest }) => (
  <Caption variant='bold' as={as} ml={'16px'} mr={'16px'} {...rest} />
)

export default NavbarLink
